import { ShippingEdit } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/user/shipping/edit")({
  component: ShippingEdit,
  beforeLoad: () => {
    document.title = "Maifud - Cambiar método de entrega";
  },
});
